import { render, staticRenderFns } from "./CreateSign.vue?vue&type=template&id=5aab3bd9&"
import script from "./CreateSign.vue?vue&type=script&lang=js&"
export * from "./CreateSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports